export const bases = [
	{
		"nombre": "1. Formato Único de Revisión de Bases 2026",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		 "url" : "/interes/1._Formato_Unico_de_Revisión_de_Bases_2026.docx"
	},
	{
		"nombre": "2. Bases Licitación Adquisición Estatal 2026",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
   	"url" : "/interes/2._Bases_Licitación_Adquisición_Estatal_2026.docx"
	},
	{
		"nombre": "3. Bases Licitación Adquisición Federal 2026",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		"url" : "/interes/3._Bases_Licitación_Adquisición_Federal_2026.docx"
		},
   {
	"nombre": "4. Bases Invitación Adquisición Estatal 2026",
	"icono":"DatosContactoUnidad.png",
	"formatos": [
		{
			// "nombre": "Las personas físicas y morales interesadas.",
			// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
			// "html": "./Transparencia/htm/a69_f13_SC.htm"
		}
	],
	"url" : "/interes/4._Bases_Invitación_Adquisición_Estatal_2026.docx"
	},
	{
		"nombre": "5. Bases Invitación Adquisición Federal 2026",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		"url" : "/interes/5._Bases_Invitación_Adquisición_Federal_2026.docx"
		},
		{
		"nombre": "6. Bases Licitación Obra Estatal 2026",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		"url" : "/interes/6._Bases_Licitación_Obra_Estatal_2026.docx"
		},
		{
		"nombre": "7. Bases Invitación Obra Estatal 2026",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		"url" : "/interes/7._Bases_Invitación_Obra_Estatal_2026.docx"
		},
		{
		"nombre": "8. Bases Licitación Obra Federal 2026",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		"url" : "/interes/8._Bases_Licitación_Obra_Federal_2026.docx"
		},
		{
			"nombre": "9. Bases Invitación Obra Federal 2026",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/9._Bases_Invitación_Obra_Federal_2026.docx"
		},

		{
			"nombre": "Manual de Oficina Virtual de Revisión de Bases",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/OV_RevisióndeBases.pdf"
		},

		{
			"nombre": "Video Virtual de Revisión de Bases",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/video/VIDEO%20TUTORIAL%20-%20OFICINA%20VIRTUAL%20DE%20BASES.mp4"
		},


		
	// 	,		
	// 	{
	// 	"nombre": "Convocatoria Lic. Adq. Estatal 2024",
	// 	"icono":"DatosContactoUnidad.png",
	// 	"formatos": [
	// 		{
	// 			// "nombre": "Las personas físicas y morales interesadas.",
	// 			// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
	// 			// "html": "./Transparencia/htm/a69_f13_SC.htm"
	// 		}
	// 	],
	// 	"url" : "/interes/Convocatoria_Lic_Adq_Estatal 2024.docx"
	// 	},
	// 	{
	// 	"nombre": "Convocatoria. Lic. Adq. Federal 2024-2.doc",
	// 	"icono":"DatosContactoUnidad.png",
	// 	"formatos": [
	// 		{
	// 			// "nombre": "Las personas físicas y morales interesadas.",
	// 			// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
	// 			// "html": "./Transparencia/htm/a69_f13_SC.htm"
	// 		}
	// 	],
	// 		"url" : "/interes/Convocatoria_Lic_Adq_Federal_2024-2.doc"
	// 	},
	// {
	// 	"nombre": "Convocatoria Lic. Obra Federal 2024.doc",
	// 	"icono":"DatosContactoUnidad.png",
	// 	"formatos": [
	// 		{
	// 			// "nombre": "Las personas físicas y morales interesadas.",
	// 			// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
	// 			// "html": "./Transparencia/htm/a69_f13_SC.htm"
	// 		}
	// 	],
	// 	"url" : "/interes/Convocatoria_Lic_Obra_Federal_2024.doc"
	// }

	
]